export const MESSAGE_WIDTH = {
    // 消息设置中的消息类型列宽
    MESSAGE_TYPE_COL_WIDTH: 180,
    // 消息设置表格的最小宽度
    MIN_MESSAGE_TABLE_WIDTH: 710
};
